'use client';

import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import * as qs from 'qs';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';

function CompactSidebarFilter({
  SIDEBAR_OPTIONS,
  dropdown_options,
  loadOptions,
  onToggle,
  isCollapsed,
}) {
  console.log('load option', loadOptions);

  const history = useHistory();
  const location = useLocation();
  const [selectedFields, setSelectedFields] = useState({});
  const [internalCollapsed, setInternalCollapsed] = useState(false);

  // Initialize selected fields based on URL params
  useEffect(() => {
    const queryParams = qs.parse(window.location.search.replace('?', ''));
    const initialFields = {};

    SIDEBAR_OPTIONS?.forEach((item) => {
      const hasValue = getSidebarValue(item);
      if (hasValue) {
        initialFields[item.id] = true;
      }
    });

    setSelectedFields(initialFields);
  }, []);

  const handleSidebarChange = ({ name, value, type = 'search', condition }) => {
    const queryParams = qs.parse(window.location.search.replace('?', ''));

    if (type === 'conditional') {
      if (!queryParams[type]) queryParams[type] = {};
      if (!queryParams[type][name]) queryParams[type][name] = {};

      if (value && value.length > 0) {
        queryParams[type][name][condition || '$gte'] = value;
      } else {
        delete queryParams[type][name][condition || '$gte'];
        if (Object.keys(queryParams[type][name]).length === 0) {
          delete queryParams[type][name];
        }
      }
    } else {
      if (!queryParams[type]) queryParams[type] = {};

      if (value && value.length > 0) {
        queryParams[type][name] = value;
      } else {
        delete queryParams[type][name];
      }
    }

    const query = qs.stringify(queryParams, { encodeValuesOnly: true });
    history.push(`${location.pathname}?${query}`);
  };

  const removeSidebarParams = (item) => {
    const queryParams = qs.parse(window.location.search.replace('?', ''));
    const searchType = item.search_type || 'search';

    if (queryParams[searchType]?.[item.field]) {
      delete queryParams[searchType][item.field];
    }

    const query = qs.stringify(queryParams, { encodeValuesOnly: true });
    history.push(`${location.pathname}?${query}`);
  };

  const getSidebarValue = (item) => {
    const queryParams = qs.parse(window.location.search.replace('?', ''));
    const searchType = item.search_type || 'search';

    if (item.search_type === 'conditional') {
      return queryParams[searchType]?.[item.field]?.[item.condition];
    }
    return queryParams[searchType]?.[item.field] || '';
  };

  const clearAllFilters = () => {
    setSelectedFields({});
    history.push(location.pathname);
  };

  const toggleField = (item, checked) => {
    setSelectedFields((prev) => ({ ...prev, [item.id]: checked }));
    if (!checked) {
      removeSidebarParams(item);
    }
  };

  const activeFiltersCount =
    Object.values(selectedFields).filter(Boolean).length;

  console.log('Active Filters Count:', dropdown_options, SIDEBAR_OPTIONS);

  return (
    <div
      className='position-sticky'
      style={{ top: '20px', backgroundColor: 'pink' }}
    >
      <div className='card shadow-sm border-0'>
        {/* Enhanced Header with Close Button */}
        <div className='card-header bg-light border-0 py-2 px-3'>
          <div className='d-flex align-items-center justify-content-between'>
            <div className='d-flex align-items-center'>
              <button
                className='btn btn-link btn-sm p-0 me-2 text-muted'
                onClick={() => setInternalCollapsed(!internalCollapsed)}
                style={{ fontSize: '11px' }}
              >
                <i
                  className={`fa fa-chevron-${
                    internalCollapsed ? 'down' : 'up'
                  }`}
                ></i>
              </button>
              <h6
                className='mb-0 fw-bold text-dark'
                style={{ fontSize: '13px' }}
              >
                <i
                  className='fa fa-filter me-2 text-primary'
                  style={{ fontSize: '12px' }}
                ></i>
                Filters
                {activeFiltersCount > 0 && (
                  <span
                    className='badge bg-primary ms-2'
                    style={{ fontSize: '9px' }}
                  >
                    {activeFiltersCount}
                  </span>
                )}
              </h6>
            </div>
            <div className='d-flex align-items-center gap-1'>
              <button
                onClick={clearAllFilters}
                className='btn btn-outline-danger btn-sm'
                disabled={activeFiltersCount === 0}
                style={{ fontSize: '10px', padding: '2px 8px' }}
                title='Clear all filters'
              >
                <i className='fa fa-times me-1' style={{ fontSize: '9px' }}></i>
                Clear
              </button>
              {onToggle && (
                <button
                  onClick={onToggle}
                  className='btn btn-outline-secondary btn-sm'
                  style={{ fontSize: '10px', padding: '2px 8px' }}
                  title='Hide sidebar'
                >
                  <i className='fa fa-times' style={{ fontSize: '9px' }}></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Sidebar Body */}
        <div
          className={`card-body px-3 py-2 ${internalCollapsed ? 'd-none' : ''}`}
        >
          {SIDEBAR_OPTIONS?.map((item, index) => (
            <div key={item.id} className='mb-3'>
              {/* Filter Toggle */}
              <div className='form-check mb-2'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id={item.id}
                  checked={selectedFields[item.id] || false}
                  onChange={(e) => toggleField(item, e.target.checked)}
                  style={{ transform: 'scale(0.9)' }}
                />
                <label
                  className='form-check-label fw-semibold text-muted'
                  htmlFor={item.id}
                  style={{ fontSize: '13px', marginLeft: '4px' }}
                >
                  {item.label}
                </label>
              </div>

              {/* Filter Input */}
              {selectedFields[item.id] && (
                <div className='ms-3'>
                  {/* String Input */}
                  {item.type === 'string' && (
                    <input
                      type={item.inputType || 'text'}
                      className='form-control form-control-sm'
                      placeholder={`Enter ${item.label.toLowerCase()}`}
                      value={getSidebarValue(item)}
                      onChange={(e) =>
                        handleSidebarChange({
                          name: item.field,
                          value: e.target.value,
                          type: item.search_type || 'search',
                          condition: item.condition,
                        })
                      }
                      style={{
                        fontSize: '12px',
                        height: '32px',
                        padding: '6px 10px',
                      }}
                    />
                  )}

                  {item.type === 'select' && (
                    <Select
                      options={
                        item.options?.map((option) => ({
                          label: option,
                          value: option,
                        })) || []
                      }
                      placeholder={`Select ${item.label}`}
                      value={
                        item.options?.some(
                          (opt) => opt === getSidebarValue(item)
                        )
                          ? {
                              label: getSidebarValue(item),
                              value: getSidebarValue(item),
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleSidebarChange({
                          name: item.field,
                          value: selectedOption?.value || '',
                          type: 'exact',
                          condition: item.condition,
                        })
                      }
                      isClearable
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '32px',
                          height: '32px',
                          fontSize: '12px',
                          padding: '0 6px',
                          border: '1px solid #ced4da',
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          padding: '0 8px',
                        }),
                        input: (base) => ({
                          ...base,
                          margin: '0',
                          padding: '0',
                        }),
                        dropdownIndicator: (base) => ({
                          ...base,
                          padding: '6px',
                        }),
                        clearIndicator: (base) => ({
                          ...base,
                          padding: '6px',
                        }),
                        menu: (base) => ({
                          ...base,
                          fontSize: '12px',
                        }),
                        option: (base) => ({
                          ...base,
                          fontSize: '12px',
                          padding: '8px 12px',
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: '12px',
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: '12px',
                        }),
                      }}
                    />
                  )}

                  {item.type === 'related' && (
                    <AsyncSelect
                      placeholder={`Search ${item.label.toLowerCase()}...`}
                      loadOptions={(inputValue) => {
                        const options = dropdown_options?.[item.field] || [];

                        // Client-side fuzzy search (case-insensitive)
                        const filtered = options.filter((opt) =>
                          opt.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        );

                        return Promise.resolve(filtered);
                      }}
                      defaultOptions={dropdown_options?.[item.field]}
                      onChange={(selectedOption) => {
                        handleSidebarChange({
                          name: item.field,
                          value: selectedOption?.value || '',
                          type: 'exact',
                          condition: item.condition,
                        });
                      }}
                      isClearable
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '36px',
                          height: '36px',
                          fontSize: '13px',
                          padding: '0 6px',
                          border: '1px solid #ced4da',
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          padding: '0 8px',
                        }),
                        input: (base) => ({
                          ...base,
                          margin: '0',
                          padding: '0',
                        }),
                        indicatorSeparator: (base) => ({
                          ...base,
                          margin: '6px 0',
                        }),
                        dropdownIndicator: (base) => ({
                          ...base,
                          padding: '6px',
                        }),
                        clearIndicator: (base) => ({
                          ...base,
                          padding: '6px',
                        }),
                        menu: (base) => ({
                          ...base,
                          fontSize: '13px',
                        }),
                        option: (base) => ({
                          ...base,
                          fontSize: '13px',
                          padding: '8px 12px',
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: '13px',
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: '13px',
                        }),
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          ))}

          {/* No Filters Message */}
          {(!SIDEBAR_OPTIONS || SIDEBAR_OPTIONS.length === 0) && (
            <div className='text-center text-muted py-4'>
              <i
                className='fa fa-filter-circle-xmark mb-3'
                style={{ fontSize: '28px' }}
              ></i>
              <p className='mb-0' style={{ fontSize: '13px' }}>
                No filters available
              </p>
            </div>
          )}
        </div>

        {/* Active Filters Summary */}
        {activeFiltersCount > 0 && !internalCollapsed && (
          <div className='card-footer bg-light border-0 py-2 px-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <small className='text-muted' style={{ fontSize: '12px' }}>
                <i
                  className='fa fa-check-circle text-success me-1'
                  style={{ fontSize: '11px' }}
                ></i>
                {activeFiltersCount} filter{activeFiltersCount !== 1 ? 's' : ''}{' '}
                active
              </small>
              <button
                className='btn btn-link btn-sm p-0 text-primary'
                onClick={() => setInternalCollapsed(true)}
                style={{ fontSize: '11px' }}
              >
                <i className='fa fa-chevron-up'></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CompactSidebarFilter;
